import React, { FC, memo, useMemo } from 'react'
import { styled, Style } from 'inlines'
import { useTheme } from '../providers/useTheme'
import { Text } from './Text'

export type CanvaProps = {
  size?: {
    width: number | string
    height: number | string
  }
  src: string
  alt?: string
  onClick?: () => void
  isFocused?: boolean
  ddi?: number
  style?: Style
}

function getOptimizedImageSrc(src: string, width: number) {
  if (
    !src ||
    !src.includes('.based.dev/') ||
    src.includes('cdn-cgi/image/') ||
    src.includes('.ico') ||
    src.startsWith('blob:')
  ) {
    return src
  }

  return src.replace('.based.dev/', `.based.dev/cdn-cgi/image/w=${width}/`)
}

export const Canva: FC<CanvaProps> = memo(
  ({
    src,
    size = {
      width: 169,
      height: 169,
    },
    alt = '',
    isFocused = false,
    ddi,
    onClick,
    style,
  }) => {
    const { colors, imageGradient } = useTheme()

    const wrapperStyle: Style = {
      ...size,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...(isFocused && {
        padding: 4,
        gap: 10,
        alignSelf: 'stretch',
        borderRadius: 24,
        border: `2px solid var(--Primary-accent, ${colors.primaryAccent})`,
      }),
      ...style,
    }

    const cardStyle: Style = {
      display: 'flex',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
      aspectRatio: '1 / 1',
      borderRadius: isFocused ? 18 : 24,
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.15)',
      background: `var(--Background, ${colors.background})`,
      overflow: 'hidden',
      position: 'relative',
    }

    const imageStyle: Style = {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
    }

    const washedOverlayStyle: Style = {
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      borderRadius: isFocused ? 18 : 24,
      background: `radial-gradient(187.51% 141.42% at 0% 0%, var(--Primary-accent, ${colors.primaryAccent}) 0%, var(--Secondary-accent, ${colors.secondaryAccent}) 100%), var(--Background, ${colors.background})`,
      opacity: 0.42,
    }

    const source = useMemo(() => {
      return getOptimizedImageSrc(src, 512)
    }, [src])

    return (
      <styled.div style={wrapperStyle} onClick={onClick}>
        <styled.div style={cardStyle}>
          <styled.img
            src={source}
            alt={alt}
            aria-hidden={!alt}
            loading="lazy"
            decoding="async"
            draggable={false}
            style={{
              ...imageStyle,
            }}
          />
          {imageGradient && (
            <styled.div aria-hidden="true" style={washedOverlayStyle} />
          )}
          {/* {ddi && (
            <styled.div
              style={{
                width: 36,
                height: 36,
                borderRadius: 999,
                position: 'absolute',
                left: 8,
                top: 8,
                background: colors.primaryAccent,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
              }}
            >
              <Text
                variant="display-medium"
                style={{
                  fontWeight: 600,
                  color: colors.background,
                  userSelect: 'none',
                }}
              >
                {ddi}
              </Text>
            </styled.div>
          )} */}
        </styled.div>
      </styled.div>
    )
  },
)
